export default {
  category: 'book',
  name: 'How to Stop Worrying and Start Living',
  author: 'Dale Carnegie',
  date: '9/10/20',
  path: '/notes/how-to-stop-worrying-and-start-living',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-how-to-stop-worrying-and-start-living-dale-carnegie.jpg',
  tags: ['Self-help'],
  time: 5,
  rating: 7.6,
  review: '',
  link: 'https://www.amazon.com/How-Stop-Worrying-Start-Living-ebook/dp/B003WIYCCY',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: '',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: ''
};
